export default __webpack_public_path__ + "static/media/bell-icon-white-elipse.9502c0d5.svg";